import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["autowidth", "defaultValue"];
var __jsx = React.createElement;
import React from "react";
import NativeSelect from "@mui/material/NativeSelect";
import DownIcon from "../Icons/NavigateDownIcon";

/**
 * Note:
 * CSS for this component must be within the component due to the nature of how
 * select appends the div to the bottom of the DOM outside of theme scope. In
 * addition if using a select inside of a popup with the parameter to keep the
 * Menu in the DOM order it doesn't work. This is the only solution I knew of to
 * remedy this without significantly modifying all behaviors.
 */
// Using the React.forwardRef to pass the same reference of ELSNativeSelect to the <NativeSelect />
var ELSNativeSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var autowidth = _ref.autowidth,
    defaultValue = _ref.defaultValue,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    /*
      @NOTE: Do not use "value" and "defaultValue" props together it would cause some errors.
      - You need a controlled component just use "value".
    */
    React.createElement(NativeSelect, _extends({
      fullWidth: true
    }, props, {
      ref: ref
    }))
  );
});
ELSNativeSelect.defaultProps = {
  value: "",
  className: "",
  IconComponent: DownIcon
};
export { ELSNativeSelect };